import React, { useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Checkbox, message } from 'antd'
import moment from 'moment'

import { updateMultipleServices } from '../services'
import { handleError } from '../../../helpers'

const options = [
	{ label: 'Marcar como Cuenta de Cobro enviada', value: 'charged_at' },
	{ label: 'Marcar como facturado', value: 'invoiced_at' },
]

export default function BulkActionServicesModal({ visible, onClose, selectedKeys, onDone }) {
	const [loading, setLoading] = useState(false)
	const [actions, setActions] = useState([])

	const handleSubmit = () => {
		if (actions.length === 0) {
			message.warning('Seleccione al menos una acción')
			return
		}
		setLoading(true)
		const value = moment().format('YYYY-MM-DD HH:mm:ss')
		const data = {}
		actions.forEach(action => { data[action] = value })

		updateMultipleServices({ service_ids: selectedKeys, data })
			.then(res => {
				message.success(res.data.message || `Acciones enviadas para ${selectedKeys.length} servicio(s)`)
				onDone()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose} centered>
			<ModalHeader toggle={onClose}>Acción masiva para {selectedKeys.length} servicio(s)</ModalHeader>
			<ModalBody>
				<p className="mb-10">Seleccione la(s) acción(es) que desea realizar con los servicios seleccionados:</p>
				<Checkbox.Group options={options} value={actions} onChange={setActions}>
					{options.map(opt => (
						<Checkbox key={opt.value} value={opt.value} className="block mb-10">{opt.label}</Checkbox>
					))}
				</Checkbox.Group>
				<hr className="mt-10" />
				<Button color="primary" onClick={handleSubmit} disabled={loading || actions.length === 0} className="d-block mx-auto">
					{loading && <Spinner animation="border" size="sm" className="mr-1" />}
					Confirmar Acción
				</Button>
			</ModalBody>
		</Modal>
	)
}